import React, { useRef } from "react";
import useForm from "./useForm";
import formValidation from "./formValidation";
import { inputsData } from "./inputsData";
import {
  ContactMeHeader,
  FormContainer,
  FormInputsContainer,
  InputWrapper,
  StyledTextField,
  SubmitButton,
} from "./StyledContactMeSection";
import { Grid } from "@mui/material";

function MyForm() {
  const { handleChange, formValues, handleSubmit, errors, isSubmitted } =
    useForm(formValidation);

  const form = useRef();

  return (
    <Grid item>
      {isSubmitted ? (
        <ContactMeHeader>
          <h3>Thank you for contacting me!</h3>
          <p>I will get back to you as soon as possible.</p>
        </ContactMeHeader>
      ) : (
        <FormContainer container item direction="column">
          <form ref={form} onSubmit={handleSubmit}>
            <FormInputsContainer
              container
              item
              justifyContent="center"
              alignItems="center"
              direction="column"
            >
              <ContactMeHeader>Contact Me!</ContactMeHeader>
              {inputsData.map((input, index) => (
                <InputWrapper container item direction="column" key={index}>
                  <StyledTextField
                    key={input.id}
                    name={input.name}
                    onChange={handleChange}
                    type={input.type}
                    placeholder={input.placeholder}
                    value={formValues[input.name]}
                    error={errors[input.name]}
                    helperText={errors[input.name]}
                    multiline
                    maxRows={2}
                    label={input.placeholder}
                    // inputProps={{
                    //   style: {
                    //     height: input.height,
                    //   },
                    // }}
                  />
                </InputWrapper>
              ))}
              <SubmitButton type="submit">sumbit here</SubmitButton>
            </FormInputsContainer>
          </form>
        </FormContainer>
      )}
    </Grid>
  );
}

export default MyForm;
